import * as React from 'react';

function SvgHowToPlay(props) {
  return (
    <svg xmlns="http://www.w3.org/2000/svg" width={24} height={24} {...props}>
      <defs>
        <clipPath id="how_to_play_svg__clip-path">
          <path
            id="how_to_play_svg__Rectangle_304"
            d="M0 0h24v24H0z"
            data-name="Rectangle 304"
            transform="translate(116 758)"
            fill={props.fill}
            stroke={props.fill}
          />
        </clipPath>
        <style>{`.how_to_play_svg__cls-3{fill:${props.fill}}`}</style>
      </defs>
      <g
        id="how_to_play_svg__how_to_play"
        transform="translate(-116 -758)"
        clipPath="url(#how_to_play_svg__clip-path)"
      >
        <g
          id="how_to_play_svg__Group_220"
          data-name="Group 220"
          transform="translate(116.343 -1281.657)"
        >
          <g id="how_to_play_svg__Group_219" data-name="Group 219" transform="translate(0 2040)">
            <g id="how_to_play_svg__Group_218" data-name="Group 218">
              <circle
                id="how_to_play_svg__Ellipse_34"
                cx={1.155}
                cy={1.155}
                r={1.155}
                className="how_to_play_svg__cls-3"
                data-name="Ellipse 34"
                transform="translate(10.673 16.333)"
              />
              <path
                id="how_to_play_svg__Path_371"
                d="M11.828 2040a11.828 11.828 0 1011.828 11.828A11.822 11.822 0 0011.828 2040zm0 21.808a9.98 9.98 0 119.98-9.98 9.975 9.975 0 01-9.98 9.98z"
                data-name="Path 371"
                transform="translate(0 -2040)"
                fill={props.fill}
              />
              <path
                id="how_to_play_svg__Path_372"
                d="M93.4 2105.5a3.7 3.7 0 00-3.7 3.7.924.924 0 001.848 0 1.848 1.848 0 111.848 1.848.924.924 0 00-.924.925v2.31a.924.924 0 001.848 0v-1.5a3.7 3.7 0 00-.924-7.276z"
                className="how_to_play_svg__cls-3"
                data-name="Path 372"
                transform="translate(-81.575 -2099.559)"
              />
            </g>
          </g>
        </g>
      </g>
    </svg>
  );
}

export default SvgHowToPlay;
